/** Liens stores — définir REACT_APP_PLAY_STORE_URL et REACT_APP_APP_STORE_URL au build. */
export const PUBLIC_MOBILE_APP = {
  playStoreUrl: (process.env.REACT_APP_PLAY_STORE_URL || '').trim(),
  appStoreUrl: (process.env.REACT_APP_APP_STORE_URL || '').trim(),
} as const;
